import camelCaseProperty from 'css-in-js-utils/lib/camelCaseProperty';

export default function generateDeclarationReference(property, value) {
  var pseudo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var media = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var support = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';

  return support + media + pseudo + camelCaseProperty(property) + value;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-dom/es/dom/rehydration/generateDeclarationReference.js
// module id = 123
// module chunks = 0